<div class="strong-green bg-light-green" *ngIf="isValidated" style="border-radius: 5px; padding: 5px 20px 5px 20px;">
  <p class="no-margin">Validé</p>
</div>